import type { BlockModel } from '@blocksuite/store';

/** Native property capture; callers choose synchronous or cooperative consumption. */
export function* getBlockPropsWork(
  model: BlockModel
): Generator<void, Record<string, unknown>> {
  yield;
  const keys = model.keys as (keyof typeof model.props)[];
  const result: Record<string, unknown> = {};
  for (const key of keys) {
    yield;
    Object.defineProperty(result, key, {
      value: model.props[key],
      enumerable: true,
      configurable: true,
      writable: true,
    });
  }
  return result;
}

export function getBlockProps(model: BlockModel): Record<string, unknown> {
  const work = getBlockPropsWork(model);
  let next = work.next();
  while (!next.done) next = work.next();
  return next.value;
}
